/* eslint-disable max-len */
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_JOB_PROFILES_REQUEST = 'LOAD_JOB_PROFILES_REQUEST';
export const LOAD_JOB_PROFILES_SUCCESS = 'LOAD_JOB_PROFILES_SUCCESS';
export const LOAD_JOB_PROFILES_FAIL = 'LOAD_JOB_PROFILES_FAIL';

export const LOAD_WORK_EFFORT_TYPES_REQUEST = 'LOAD_WORK_EFFORT_TYPES_REQUEST';
export const LOAD_WORK_EFFORT_TYPES_SUCCESS = 'LOAD_WORK_EFFORT_TYPES_SUCCESS';
export const LOAD_WORK_EFFORT_TYPES_FAIL = 'LOAD_WORK_EFFORT_TYPES_FAIL';

export const POST_JOB_PROFILE_REQUEST = 'POST_JOB_PROFILE_REQUEST';
export const POST_JOB_PROFILE_REQUEST_SUCCESS = 'POST_JOB_PROFILE_REQUEST_SUCCESS';
export const POST_JOB_PROFILE_REQUEST_FAIL = 'POST_JOB_PROFILE_REQUEST_FAIL';

export const DELETE_JOB_PROFILE_REQUEST = 'DELETE_JOB_PROFILE_REQUEST';
export const DELETE_JOB_PROFILE_SUCCESS = 'DELETE_JOB_PROFILE_SUCCESS';
export const DELETE_JOB_PROFILE_FAIL = 'DELETE_JOB_PROFILE_FAIL';

export const PUT_JOB_PROFILE_REQUEST = 'PUT_JOB_PROFILE_REQUEST';
export const PUT_JOB_PROFILE_SUCCESS = 'PUT_JOB_PROFILE_SUCCESS';
export const PUT_JOB_PROFILE_FAIL = 'PUT_JOB_PROFILE_FAIL';

const loadJobProfilesSuccess = (list) => ({ type: LOAD_JOB_PROFILES_SUCCESS, list });
const loadJobProfilesRequest = () => ({ type: LOAD_JOB_PROFILES_REQUEST });
const loadJobProfilesFail = (error) => ({ type: LOAD_JOB_PROFILES_FAIL, error });

const loadWorkEffortTypesRequest = () => ({ type: LOAD_WORK_EFFORT_TYPES_REQUEST });
const loadWorkEffortTypesSuccess = (list) => ({ type: LOAD_WORK_EFFORT_TYPES_SUCCESS, list });
const loadWorkEffortTypesFail = (error) => ({ type: LOAD_WORK_EFFORT_TYPES_FAIL, error });

const postJobProfileSuccess = (data) => ({ type: POST_JOB_PROFILE_REQUEST_SUCCESS, data });
const postJobProfileRequest = (data) => ({ type: POST_JOB_PROFILE_REQUEST, data });
const postJobProfileFail = (error) => ({ type: POST_JOB_PROFILE_REQUEST_FAIL, error });

const deleteJobProfileRequest = (jobProfileId) => ({ type: DELETE_JOB_PROFILE_REQUEST, jobProfileId });
const deleteJobProfileFail = (error) => ({ type: DELETE_JOB_PROFILE_FAIL, error });
const deleteJobProfileSuccess = (jobProfileId) => ({ type: DELETE_JOB_PROFILE_SUCCESS, jobProfileId });

const putJobProfileSuccess = (data) => ({ type: PUT_JOB_PROFILE_SUCCESS, data });
const putJobProfileRequest = (data) => ({ type: PUT_JOB_PROFILE_REQUEST, data });
const putJobProfileFail = (error) => ({ type: PUT_JOB_PROFILE_FAIL, error });

export const loadJobProfiles = () => (dispatch) => {
  dispatch(loadJobProfilesRequest());
  return communicate({ url: 'JobProfiles', method: 'get' }).then((response) => {
    dispatch(loadJobProfilesSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(loadJobProfilesFail(e));
    toastrError(e);
  });
};

export const loadWorkEfforts = () => (dispatch) => {
  dispatch(loadWorkEffortTypesRequest());
  return communicate({ url: 'WorkEffortTypes', method: 'get' }).then((response) => {
    dispatch(loadWorkEffortTypesSuccess(response.data.Data));
  }).catch((e) => {
    dispatch(loadWorkEffortTypesFail(e));
    toastrError(e);
  });
};

export const postJobProfile = (params) => (dispatch) => {
  dispatch(postJobProfileRequest(params));
  return communicate({ url: 'JobProfiles', method: 'post', data: params })
    .then((response) => {
      dispatch(postJobProfileSuccess(response.data.Data));
      dispatch(loadJobProfiles());
      toastrSuccess(response);
    }).catch((e) => {
      dispatch(postJobProfileFail(e));
      toastrError(e);
    });
};

export const deleteJobProfile = (jobProfileId) => (dispatch) => {
  dispatch(deleteJobProfileRequest(jobProfileId));
  return communicate({ url: 'JobProfiles', method: 'delete', getParams: `?id=${jobProfileId}` })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteJobProfileSuccess(jobProfileId));
    }).catch((err) => {
      dispatch(deleteJobProfileFail(err));
      toastrError(err);
    });
};

export const putJobProfile = (params) => (dispatch) => {
  dispatch(putJobProfileRequest(params));
  return communicate({
    url: 'JobProfiles',
    method: 'put',
    data: params
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(putJobProfileSuccess(params));
      dispatch(loadJobProfiles());
    }).catch((err) => {
      dispatch(putJobProfileFail(err));
      toastrError(err);
    });
};
